import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, filter, map, mergeMap, Observable, combineLatest } from 'rxjs';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { NavigationItem } from '../types/navigation';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { getMenu } from 'src/app/components/data/menu';

export interface titleType {
  // eslint-disable-next-line
  url: string | boolean | any | undefined;
  title: string;
  breadcrumbs: unknown;
  type: string;
  link: string | undefined;
  fragment?: string | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {


  _navigationList: BehaviorSubject<titleType[]> = new BehaviorSubject<titleType[]>([]);
  _visibility: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  navigations: NavigationItem[];
  breadcrumb: Observable<titleType[]> = this._navigationList.asObservable();
  visibility: Observable<boolean> = this._visibility.asObservable();

  url: any;


  constructor(private route: Router, private titleService: Title, private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.navigations = getMenu();
    this.setBreadcrumb();
  }

  private set navigationList(v: titleType[]) {
    this._navigationList.next(v);

  }

  private get navigationList(): titleType[] {
    return this._navigationList.getValue();

  }

  setBreadcrumb() {
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route: ActivatedRoute) => {
        while (route['firstChild']) {
          route = route['firstChild'];
        }
        return route;
      }),
      filter((route: ActivatedRoute) => route['outlet'] === 'primary'),
      mergeMap((route: ActivatedRoute) => combineLatest([route['data'], route['url']])))
      .subscribe((data: any[]) => {
        const url = data[1].map((segment: any) => segment.path).join('/');

        if (this.url !== url) {
          this.url = url;
          let activeLink = url.split('?')[0];

          const parts = activeLink.split('/').filter(Boolean); // ["lists", "1"]

          activeLink = '/' + parts[0]; // "/lists"
          const breadcrumbList = this.filterNavigation(this.navigations, activeLink);
          this.navigationList = breadcrumbList;
          const routerdata = data[0];
          if (routerdata && routerdata['title']) {
            this.addDetail({ title: routerdata['title'], param: routerdata['param'] || '' });
          }


        }
      });

  }


  setTitle() {
    const breadcrumbList = this.navigationList;
    if (breadcrumbList.length === 0) {
      this.titleService.setTitle(environment.title);
      return;
    }
    const title = breadcrumbList[breadcrumbList.length - 1]?.title;
    this.titleService.setTitle(title ? title + ' | ' + environment.title : environment.title);
  }

  filterNavigation(navItems: NavigationItem[], activeLink: string): titleType[] {
    for (const navItem of navItems) {
      if (navItem.type === 'item' && 'url' in navItem && navItem.url === activeLink) {
        return [
          {
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            link: navItem.link,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          }
        ];
      }
      if ((navItem.type === 'group' || navItem.type === 'collapse') && 'children' in navItem) {
        const breadcrumbList = this.filterNavigation(navItem.children!, activeLink);
        if (breadcrumbList.length > 0) {
          breadcrumbList.unshift({
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            link: navItem.link,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          });
          return breadcrumbList;
        }
      }
    }
    return [];
  }

  setLoading() {
    this._visibility.next(false);
  }

  addDetail(arg: { title: string; param: any; }) {
    if (!arg || !arg.title) {
      return;
    }
    this.addDetails([arg]);
  }
  addDetails(args: { title: string; param: any; url?: string, fragment?: string }[]) {
    if (!args || !args.length || !args[0].title) {
      return;
    }


    for (const arg of args) {
      const param = arg.param ? { value: arg.param } : {};
      this.translateService.get(arg.title, param).subscribe(message => {
        const title = message;
        this.navigationList = [...this.navigationList, {
          url: arg.url || false,
          title: title,
          link: undefined,
          breadcrumbs: true,
          fragment: arg.fragment,
          type: 'item'
        }];

        this.setTitle();
      });
    }
    this._visibility.next(true);
  }



}
